// extracted by mini-css-extract-plugin
export var actions = "_5y-8";
export var arrow = "_5y-5";
export var card = "_5y-0";
export var cardWrapper = "_5y-9";
export var fieldName = "_5y-3";
export var newValue = "_5y-6";
export var oldValue = "_5y-4";
export var orangeGlowFade = "_5y-c";
export var productSection = "_5y-1";
export var scrollToBottom = "_5y-b";
export var scrollToBottomAnchor = "_5y-a";
export var scrollToBottomIcon = "_5y-d";
export var showAllButton = "_5y-7";
export var table = "_5y-2";